export enum DeeplinkKind {
  Task = 'task',
  ProjectJson = 'projectJson',
  Preset = 'preset',
  Category = 'category',
  None = 'none',
}

export type Deeplink =
  | { kind: DeeplinkKind.Task; taskId: string }
  | { kind: DeeplinkKind.ProjectJson; jsonUrl: string }
  | { kind: DeeplinkKind.Preset; presetId: string }
  | { kind: DeeplinkKind.Category; category: string }
  | { kind: DeeplinkKind.None };
